import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.5),
        },
        link: {
            color: theme.palette.primary.dark,
            whiteSpace: 'normal',
            wordBreak: 'break-all',
        },
        delete: {
            padding: `${theme.spacing(0.7)} !important`,
        },
        fileSize: {
            whiteSpace: 'nowrap',
        },
    }
})

export default useStyles
